import React, { useState } from 'react';
import ButtonGroup from '@visa/vds/button-group';
import ButtonText from '@visa/vds/button-text';
import Dialog from '@visa/vds/dialog';
import DialogCardBody from '@visa/vds/dialog-card-body';
import DialogCardFooter from '@visa/vds/dialog-card-footer';
import DialogCardHead from '@visa/vds/dialog-card-head';
import DialogCardHeadTitle from '@visa/vds/dialog-card-head-title';
import Grid from '@visa/vds/grid';
import Row from '@visa/vds/row';
import Col from '@visa/vds/col';
import MCSSpace from '../../../components/MCSSpace';
import {adminService} from '../../../services/admin.service';
import MCSOverlayLoading from '../../../components/MCSOverlayLoading';
import { approveOrganizationDto } from '../../../_mappings/Organization';


const OrganizationAccessDialog = (props) => {

    const [loading,setLoading] = useState(false);
    const dtoMapping = (orgDto,org) => {
        orgDto.organizationName = org.orgName;
        orgDto.bid = org.bid;
        orgDto.volOrgId = org.id;
        orgDto.regionCode = org.regionCode;
        orgDto.orgCountryCode = org.countryCode;
        orgDto.orgType = org.orgType;
        orgDto.repFirstName = org.repFirstName;
        orgDto.repLastName = org.repLastName;
        orgDto.repAddressLineOne = org.repAddress1;
        orgDto.repAddressLineTwo = org.repAddress2;
        orgDto.repCity = org.orgCity;
        orgDto.repState = org.orgState;
        orgDto.repCountryCode = org.countryCode;
        return orgDto;
    }

    const approveOrg = async () => {
        setLoading(true);
        let org = props.organization;
        let mappedDto = dtoMapping(approveOrganizationDto,org);

        const Response = await adminService.ApproveOrganization(mappedDto);

        if(Response.success){
            props.alertObj.setSuccessMessage("Organization successfully approved");
        }else{
            props.alertObj.setErrorMessage("Organization failed to be approved: " + Response.error.message);
        }

        props.tablesRefresh();
        props.setSelectedOrganization(null)
        setLoading(false);
    }

    return (
    <>
    {loading && 
    <MCSOverlayLoading/>}
    <Dialog
    aria-describedby="Accept Organization Access Request"
    onExit={() => {}}
    open={props.openOrgAccessDialog}
    titleId="dialog-accept-org"
>
        <DialogCardHead>
            <DialogCardHeadTitle id="dialog-title-manage-file">Access Request - Organization Details</DialogCardHeadTitle>
        </DialogCardHead>
        <DialogCardBody id="dialog-description-manage-file-field">
            <Grid>
                <Row noGutter>
                    <Col noTopGutter noGutter lg={5}>
                        <b>Organization</b><br/>
                        {props.organization && props.organization.orgName}
                    </Col>
                    <Col noTopGutter noGutter lg={6}>
                        <b>BID</b><br/>
                        {props.organization && props.organization.bid}
                    </Col>
                </Row>
                <MCSSpace/>
                <Row noGutter>
                    <Col noTopGutter noGutter lg={5}>
                        <b>Region</b><br/>
                        {props.organization && props.organization.regionName}
                    </Col>

                    <Col noTopGutter noGutter lg={6}>
                        <b>Country</b><br/>
                        {props.organization && props.organization.countryName}
                    </Col>
                </Row>
                <MCSSpace/>
                <Row noGutter>
                    <Col noTopGutter noGutter lg={5}>
                        <b>Primary Visa Contact</b><br/>
                        {props.organization && props.organization.primaryVisaContact}
                    </Col>
                </Row>
            </Grid>
            <MCSSpace/>
        </DialogCardBody>
        <DialogCardFooter>
            <ButtonGroup direction="right">
                <ButtonText
                    colorScheme="secondary"
                    onClick={() => {props.setSelectedOrganization(null)}}
                    >
                    Cancel
                </ButtonText>
                <ButtonText
                colorScheme="primary"
                onClick={() => {
                    approveOrg()
                }}
                >
                    Approve 
                </ButtonText>

                </ButtonGroup>
        </DialogCardFooter>
    </Dialog>
    </>

    )
}


export default OrganizationAccessDialog